"use client";

import { ArrowLeft } from "lucide-react";

export default function StepMarker({ currentStep, totalSteps, onBack }) {
  return (
    <div className="flex items-center justify-between mb-6">
      <button
        onClick={onBack}
        className="flex items-center text-gray-600 hover:text-gray-800"
      >
        <ArrowLeft size={20} className="mr-2" />
        Back
      </button>

      <div className="flex items-center space-x-2">
        {Array.from({ length: totalSteps }, (_, index) => (
          <div
            key={index}
            className={`w-2 h-2 rounded-full ${
              index + 1 <= currentStep ? "bg-[#7B189F]" : "bg-gray-300"
            }`}
          />
        ))}
      </div>

      <div className="text-sm text-gray-500">
        {currentStep}/{totalSteps}
      </div>
    </div>
  );
}
